var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show === 'register')?_c('Register'):_vm._e(),(_vm.show === 'AppSumo')?_c('AppSumoRegister'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }